function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TdPagination from '@/components/TdPagination/index';
import { doGetRequest, doPostRequest } from '@/api/base';
export default {
  name: 'TdTable',
  components: {
    TdPagination: TdPagination
  },
  props: {
    rowKey: {
      type: String,
      default: ''
    },
    expend: {
      type: Boolean,
      default: false
    },
    needPagination: {
      type: Boolean,
      default: true
    },
    requestMethod: {
      type: String,
      default: 'GET'
    },
    // 页面唯一Key
    defaultEventKey: {
      type: String,
      default: ''
    },
    mainAttr: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    listKey: {
      type: String,
      default: 'list'
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    defaultLoadData: {
      type: Boolean,
      default: true
    },
    reqConfig: {
      type: Object,
      default: function _default() {
        return {
          queryUrl: ''
        };
      }
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    tableBindColumns: {
      type: Array,
      default: function _default() {
        return [
          /**
           * { label: '类型', prop: 'fieldType', localDict: filterBlackType, tagType: 'info' },
           * label 表格展示的列名
           * prop json 数据字段名称
           * localDict 本地数据字典函数
           * tagType 统一 el-tag 样式类型
           */
        ];
      }
    }
  },
  data: function data() {
    return {
      currentPageKey: this.$route.path,
      loading: false,
      dataList: [],
      ids: [],
      queryParams: {},
      totalRecord: 0,
      pagination: {
        current: 1,
        limit: 20
      },
      finalTableColumns: []
    };
  },
  watch: {
    dataList: {
      handler: function handler(data) {
        this.reLayout();
      }
    },
    tableBindColumns: {
      handler: function handler(data) {
        var isAdmin = this.$store.state.user.isAdmin;
        console.log('this.$store.state.user.isAdmin', isAdmin);
        if (isAdmin) {
          this.finalTableColumns = _.cloneDeep(data);
        } else {
          var tempList = _.cloneDeep(data);
          this.finalTableColumns = tempList.filter(function (x) {
            return !x.hasOwnProperty('needAdmin') || x.hasOwnProperty('needAdmin') && !x['needAdmin'];
          });
        }
      },
      deep: true,
      immediate: true
    },
    finalTableColumns: {
      handler: function handler(data) {
        this.reLayout();
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$EventBus.$off("".concat(this.currentPageKey).concat(this.defaultEventKey));
  },
  mounted: function mounted() {
    var _this = this;
    this.$EventBus.$on("".concat(this.currentPageKey).concat(this.defaultEventKey), function (queryParams) {
      console.log('data table event bus');
      _this.doQueryData(true, queryParams);
    });
    if (this.defaultLoadData) {
      // this.doQueryData(true)
    }
  },
  methods: {
    doPageQuery: function doPageQuery(page) {
      if (this.showPagination) {
        this.pagination.current = page.page;
        this.pagination.limit = page.limit;
      }
      this.doQueryData(false, this.queryParams);
      this.$emit('pageChange', page);
    },
    doQueryData: function doQueryData() {
      var _this2 = this;
      var toFirst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (queryParams) {
        this.queryParams = queryParams;
      }
      if (!this.reqConfig.queryUrl) {
        console.error('没有参数 reqConfg.queryUrl');
        return;
      }
      // 如果是第一页 重置页码
      if (toFirst) {
        this.pagination.current = 1;
      }
      this.queryParams.page = this.pagination.current;
      this.queryParams.limit = this.pagination.limit;
      this.loading = true;
      if (this.requestMethod === 'GET') {
        doGetRequest(this.reqConfig.queryUrl, this.queryParams).then(function (res) {
          if (_this2.needPagination) {
            _this2.dataList = res[_this2.listKey];
            _this2.totalRecord = Number(res.total);
          } else {
            _this2.dataList = res;
            _this2.totalRecord = res.length;
            _this2.pagination.limit = res.length;
          }
          _this2.loading = false;
          if (res.hasOwnProperty('page')) {
            _this2.pagination.current = Number(res.page);
          }
          _this2.reLayout();
        }).catch(function (e) {
          _this2.loading = false;
        });
      } else {
        doPostRequest(this.reqConfig.queryUrl, this.queryParams).then(function (res) {
          if (_this2.needPagination) {
            _this2.dataList = res[_this2.listKey];
            _this2.totalRecord = Number(res.total);
          } else {
            _this2.dataList = res[_this2.listKey];
            _this2.totalRecord = res[_this2.listKey].length;
          }
          _this2.loading = false;
          if (res.hasOwnProperty('page')) {
            _this2.pagination.current = Number(res.page);
          }
          _this2.reLayout();
        }).catch(function (e) {
          _this2.loading = false;
        });
      }
    },
    getDictTagType: function getDictTagType(row, prop, text) {
      if (!prop) return '';
      var tempColumn = this.finalTableColumns.find(function (x) {
        return x.prop === prop;
      });
      if (!tempColumn.hasOwnProperty('localDict')) {
        return false;
      }
      var item = tempColumn.localDict.find(function (item) {
        return item.label === text;
      });
      if (item) {
        return item.tagType;
      }
      return false;
    },
    tableItemText: function tableItemText(row, prop, text, index, type) {
      if (!prop) return '';
      var tempColumn = this.finalTableColumns.find(function (x) {
        return x.prop === prop;
      });
      if (!tempColumn) {
        return '-';
      }
      if (tempColumn && tempColumn.formatter) {
        return tempColumn.formatter(row, text, index);
      }
      var val = '';
      var childProp = prop.split('.');
      if (childProp && childProp.length > 1) {
        var base = row;
        var _iterator = _createForOfIteratorHelper(childProp),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var tempKey = _step.value;
            if (base[tempKey]) {
              base = base[tempKey];
            } else {
              return '';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        val = base;
      } else {
        val = row[prop];
      }
      if (tempColumn && tempColumn.hasOwnProperty('localDict')) {
        var tempItem = tempColumn.localDict.find(function (item) {
          return item.value === val;
        });
        if (tempItem) {
          return tempItem.label;
        }
        return '-';
      }
      return val;
    },
    reLayout: function reLayout() {
      var _this3 = this;
      this.$nextTick(function () {
        if (_this3.$refs.dataTable) {
          _this3.$refs.dataTable.doLayout();
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val);
    },
    clearChecked: function clearChecked() {
      var _this4 = this;
      if (this.multiSelect) {
        this.$nextTick(function () {
          _this4.$refs.dataTable.clearSelection();
        });
      }
    }
  }
};